module.exports = __webpack_public_path__ + "img/RedBag_logo-white.06a67bf.svg";